import _decrypt from "./_decrypt";
import _encrypt from "./_encrypt";
import _britex from "./_britex";
import _api from "./_api";
import _config from "./_config"
import _apiEndPoints from "./json/apiEndPoints.json";
import _screen from "./_screen";
import _placeholder from "./_placeholder";
import _datediff from "./_datediff";
import _resolvers from "./_resolvers";
import _bs from "./_bs";
import _routes from "./_routes";
import _authIcon from "./_icon";
import _datetimeNow from "./_datetimeNow";
import _dateNow from "./_dateNow";
import RESOLVERS from "./ENUMS/RESOLVERS";
import SIZE from "./ENUMS/SIZE";
import VARIANT from "./ENUMS/VARIANT";
import { useSearchParams, useNavigate, useLocation, useParams } from "react-router-dom";

export default function BrtxFunction(Component) {
    function ComponentWithRouter(props) {
      return (
        <Component
          {...props}
          _api={_api}
          DateNow={_dateNow}
          DateTimeNow={_datetimeNow}
          _bs={_bs}
          Bs={_bs}
          _icon={_authIcon}
          Icon={_authIcon}
          _decrypt={_decrypt}
          _encrypt={_encrypt}
          _routes={_routes}
          BrtxRoute={_routes}
          RESOLVERS={RESOLVERS}
          SIZE={SIZE}
          VARIANT={VARIANT}
          _config={_config}
          Config={_config}
          _defaultImg={_britex}
          screen={_screen()}
          _datediff={_datediff}
          _placeholder={_placeholder}
          Placeholder={_placeholder}
          getParams={useSearchParams()}
          setNavigate={useNavigate()}
          getLocation={useLocation()}
          params={useParams()}
          _endPoints={_apiEndPoints}
          _resolvers={_resolvers}
        />
      );
    }
    return ComponentWithRouter;
  }